function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Rect from '@reach/rect';
import WindowSize from '@reach/window-size';
import EBPropTypes from 'js-utils/prop-types';
import lazyGettext from 'js-utils/lazy-gettext';
import { setWindowLocation, openInNewTab } from 'js-utils/http';
import Dropdown from '../containers/dropdown/Dropdown';
import IconButton from '../iconButton/IconButton';
import TextList from '../textList/TextList';
import { ALIGN_PROP_TYPE, ALIGN_RIGHT } from '../containers/dropdown/constants';
import { TEXT_ITEMS_PROP_TYPE } from '../textList/constants';
import { STYLE_PROP_TYPE, STYLE_NEUTRAL } from '../iconButton/constants';
import { SVG_PROP_TYPE } from '../vectorImage/constants';
import { TYPE_LINK } from '../button/constants';
import { calculateShouldDropUp } from './utils';
import VerticalDotsChunkySvg from '../iconography/icons/VerticalDotsChunky';

var Actions = function Actions(_ref) {
  var showActions = _ref.showActions,
      items = _ref.items,
      align = _ref.align,
      onHide = _ref.onHide,
      onAction = _ref.onAction;
  var triggerRef = null;

  if (showActions) {
    var className = classNames('eds-more-actions__dropdown', "eds-more-actions--align-".concat(align));
    return React.createElement(WindowSize, null, function (windowSize) {
      return React.createElement(Rect, {
        observe: true
      }, function (_ref2) {
        var rect = _ref2.rect,
            ref = _ref2.ref;
        return React.createElement("div", {
          className: className,
          ref: function ref(node) {
            triggerRef = node;
          },
          "data-spec": "actions-dropdown"
        }, React.createElement(Dropdown, {
          align: align,
          onClickOutside: onHide,
          dropUp: calculateShouldDropUp({
            rect: rect,
            windowSize: windowSize,
            triggerRef: triggerRef
          })
        }, React.createElement(TextList, {
          innerRef: ref,
          items: items,
          onItemSelect: onAction,
          shouldCalculateDimensions: true
        })));
      });
    });
  }

  return null;
};

var MoreActions =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MoreActions, _PureComponent);

  function MoreActions() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MoreActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MoreActions)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showActions: false
    });

    _defineProperty(_assertThisInitialized(_this), "_passVisibilityState", function () {
      if (_this.props.onToggleVisibility) {
        _this.props.onToggleVisibility(_this.state.showActions);
      }
    });

    return _this;
  }

  _createClass(MoreActions, [{
    key: "_toggleDropdown",
    value: function _toggleDropdown() {
      this.setState(function (_ref3) {
        var prevShowActions = _ref3.showActions;
        return {
          showActions: !prevShowActions
        };
      }, this._passVisibilityState);
    }
  }, {
    key: "_hideDropdown",
    value: function _hideDropdown() {
      this.setState({
        showActions: false
      }, this._passVisibilityState);
    }
  }, {
    key: "_handleOnActionItem",
    value: function _handleOnActionItem(value, index, syntheticEvent) {
      var _this$props$items$ind = this.props.items[index],
          path = _this$props$items$ind.path,
          buttonType = _this$props$items$ind.buttonType;

      this._hideDropdown();

      if (this.props.onAction) {
        this.props.onAction(value, index, syntheticEvent);
      } else if (buttonType === TYPE_LINK) {
        if (syntheticEvent.shiftKey) {
          window.open(path);
        } else if (syntheticEvent.ctrlKey || syntheticEvent.metaKey) {
          openInNewTab(path);
        } else {
          setWindowLocation(path);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          dropdownAlign = _this$props.dropdownAlign,
          iconType = _this$props.iconType,
          style = _this$props.style,
          title = _this$props.title,
          isDisabled = _this$props.isDisabled;
      var showActions = this.state.showActions;
      var ariaExpanded; // if the actions are being shown then the aria label should be true
      // otherwise it shouldn't show so it should be `undefined`

      if (showActions) {
        ariaExpanded = true;
      }

      return React.createElement("div", {
        className: "eds-more-actions"
      }, React.createElement(IconButton, {
        iconType: iconType,
        style: style,
        onClick: this._toggleDropdown.bind(this),
        "data-spec": "eds-more-actions-toggle",
        title: title,
        "aria-haspopup": true,
        "aria-expanded": ariaExpanded,
        isDisabled: isDisabled
      }), React.createElement(Actions, {
        showActions: showActions,
        items: items,
        align: dropdownAlign,
        onHide: this._hideDropdown.bind(this),
        onAction: this._handleOnActionItem.bind(this)
      }));
    }
  }]);

  return MoreActions;
}(PureComponent);

_defineProperty(MoreActions, "propTypes", {
  /**
   * Array of list item data.
   */
  items: TEXT_ITEMS_PROP_TYPE.isRequired,
  dropdownAlign: ALIGN_PROP_TYPE,

  /**
   * The type of icon that you want to display e.g. alert
   */
  iconType: SVG_PROP_TYPE,

  /**
   * The style of the icon button
   */
  style: STYLE_PROP_TYPE,

  /**
   * Callback function that will be called when a action item is selected
   * (value, index) => {}
   */
  onAction: PropTypes.func,

  /**
   * Configurable title for icon button. Must be the result of gettext() for localization
   */
  title: EBPropTypes.translation,

  /**
   * Function that will be passed the current visibility state of the action menu
   */
  onToggleVisibility: PropTypes.func,

  /**
   * Disable component
   */
  isDisabled: PropTypes.bool
});

_defineProperty(MoreActions, "defaultProps", {
  iconType: React.createElement(VerticalDotsChunkySvg, null),
  style: STYLE_NEUTRAL,
  dropdownAlign: ALIGN_RIGHT,
  title: lazyGettext('View more actions'),
  isDisabled: false
});

export { MoreActions as default };